export default {
  key: 'html',
  lang: 'html',
  // The server-generated snippet is the single source of truth, so it is
  // returned as-is; the dialog scrubs the leading indentation before display.
  generate: ({ webWidgetScript }) => webWidgetScript,
};
